<ng-template #dialogHead>
  <label class="label-title">{{isUpdate ? 'Edit' : 'New'}} Notification</label>
  <button mat-icon-button (click)="onClose()" class="custom-mat-icon-button button-close-panel">
    <mat-icon svgIcon="ico-close" class="custom-mat-icon ico-size ico-2xs"></mat-icon>
  </button>
</ng-template>

<ng-template #dialogBody>
  <div class="form-wrapper">
    <div class="form-content">
      <div class="form-section">
        <div class="form-section-container">
          <div class="form-section-body">
            <div *ngIf="formData" class="form-section-body">
              <mat-form-field class="custom-mat-form-field size size1of1">
                <mat-label>Sender</mat-label>
                <input matInput [formControl]="fromFieldControl">
              </mat-form-field>
            </div>
            <new-notifications
            [_data]=data
            [formData]="formData"
            (_emitDisableButton)="onGetDisableButton($event)"
            (_emitData)="onGetData($event)">
            </new-notifications>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #dialogNav>
  <button mat-flat-button (click)="onSubmit()" color="primary" [disabled]="disableButton" class="mat-button custom-mat-button-primary">{{formData ? 'Edit Notification' : 'Create Notification'}}</button>
</ng-template>

<app-dialog
  [dialogHead]="dialogHead"
  [dialogBody]="dialogBody"
  [dialogNav]="dialogNav">
</app-dialog>
